import React, { useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { find } from 'lodash';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Row from '../Grid/Row';
import Col from '../Grid/Col';
import FormGroup from '../Formik/FormGroup';
import TimeRangePickerField from '../Formik/TimeRangePickerField.jsx';
import { Submit } from '../Formik/Submit';
import CarSelect from './CarSelect';
import { saveReservation } from '../../actions/reservationActions';
import LotSelect from './LotSelect';
import { BOOKING_DONE_ROUTE } from '../router/routes';
import DateFieldGroup from './DateFieldGroup';
import config from '../../config';
import { saveRecaptcha } from '../../actions/authenticationActions';

function BookingForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const tomorrow = new Date();
  const submitBtn = useRef();
  const formikRef = useRef();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const defaultCar = useSelector((state) =>
    find(state.cars, (car) => car.primary === true)
  );

  async function handleSubmit(values) {
    const reservation = {
      dateFrom: values.date,
      dateTo: values.date,
      timeFrom: values.timeFrom,
      timeTo: values.timeTo,
      lotId: values.lot,
      carId: values.car
    };

    try {
      const data = await dispatch(saveReservation(reservation));
      history.push(BOOKING_DONE_ROUTE, data);
    } catch (err) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
      }
    }
  }

  function onSuccess(token) {
    formikRef.current.submitForm();
    dispatch(saveRecaptcha(token));
    window.grecaptcha.reset();
  }

  useEffect(() => {
    window.grecaptcha.render(submitBtn.current, {
      size: 'invisible',
      callback: onSuccess,
      sitekey: config.recaptchaCode
    });
  }, []);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        date: tomorrow,
        car: defaultCar && defaultCar.carId,
        lot: 312,
        timeFrom: '09:00',
        timeTo: '17:00'
      }}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {() => (
        <Form>
          <DateFieldGroup name="date" />
          <Row>
            <Col>
              <LotSelect />
            </Col>
            <Col>
              <CarSelect />
            </Col>
          </Row>
          <FormGroup className="time__range">
            <TimeRangePickerField nameFrom="timeFrom" nameTo="timeTo" />
          </FormGroup>
          <FormGroup style={{ textAlign: 'center' }}>
            <input
              className="btn"
              value="Rezervovat"
              ref={submitBtn}
              type="submit"
            />
          </FormGroup>
        </Form>
      )}
    </Formik>
  );
}

export default BookingForm;
